import { Collapse, HStack, Icon, Text, VStack } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import useAnvaFlowProductSelectionStore from '@flows/src/store/zustand/flows-products/useAnvaFlowProductSelectionStore';
import AnvaFlowProductsSideBarBasketItem from '@flows/src/components/flow-products/sidebar/AnvaFlowProductsSideBarBasketItem';
import useAnvaFlowProductsBasketStore from '@flows/src/store/zustand/flows-products/useAnvaFlowProductsBasketStore';

const AnvaFlowProductsSideBarBasketItems = () => {
  const { t } = useTranslation();
  const selectedItems = useStoreWithEqualityFn(
    useAnvaFlowProductSelectionStore,
    (state) => state.selectedItems,
    (a, b) => a.length === b.length,
  );
  const allQuotes = useAnvaFlowProductsBasketStore((state) => [
    ...state.insurances,
    ...state.packages.flatMap((pkg) => pkg.quotes),
  ]);

  const filteredItems = selectedItems.filter(
    (item) =>
      !allQuotes.some(
        (quote) =>
          quote.anva_product_id === item.anva_product_id &&
          quote.index === item.index,
      ),
  );

  return (
    <VStack spacing="6" align="stretch" mx="4">
      <VStack align="flex-start">
        <Text textStyle="normalBodyMedium">
          {t('FLOWS_PRODUCT-CART_WIDGET_TITLE')}
        </Text>
        <Text textStyle="smallBody" color="gray.500">
          {t('FLOWS_PRODUCT-BASKET_SIDEBAR_DESCRIPTION')}
        </Text>
      </VStack>
      <div>
        <Collapse in={filteredItems.length === 0} unmountOnExit>
          <HStack>
            <Icon name="GeneralStatusSuccessCheckmark" color="gray.300" />
            <Text textStyle="smallBody" color="gray.300">
              {t('FLOWS_PRODUCT-BASKET_EMPTY')}
            </Text>
          </HStack>
        </Collapse>
        <VStack spacing="2" align="stretch">
          {filteredItems.map((item) => (
            <AnvaFlowProductsSideBarBasketItem key={item.id} data={item} />
          ))}
        </VStack>
      </div>
    </VStack>
  );
};

export default AnvaFlowProductsSideBarBasketItems;
